import React from 'react';
import './Cell.scss';

const Cell = ({ onClick, value }: {onClick: () => void, value: boolean}) => (
  <button
    type="button"
    className={value ? 'grid-cel active' : 'grid-cel'}
    onClick={() => onClick()}
  >
    {value}
  </button>
);

export default Cell;
